export default __webpack_public_path__ + "static/media/slot10.7ccebc49.png";